import React from 'react';
import './ManPage.css';

export interface ManSection {
  heading: string;
  body: React.ReactNode;
}

export function ManPage({
  name,
  section = '1',
  manual = 'User Manual',
  sections,
  children,
  noHeader = false
}: {
  name: string;
  section?: string;
  manual?: string;
  sections?: ManSection[];
  children?: React.ReactNode;
  noHeader?: boolean;
}): JSX.Element {
  const header = `${name.toUpperCase()}(${section})`;
  const headerLine = (
    <div className="man-header-row">
      <span>{header}</span>
      <span>{manual}</span>
      <span>{header}</span>
    </div>
  );

  return (
    <pre className="man-body">
      {!noHeader && headerLine}
      {!noHeader && '\n'}
      {sections?.map((s, i) => (
        <div key={i} className="man-section">
          <div className="man-heading">{s.heading}</div>
          <div className="man-content">{s.body}</div>
          {'\n'}
        </div>
      ))}
      {children}
      {!noHeader && headerLine}
    </pre>
  );
}
